import React from 'react'
import PropTypes from 'prop-types'

const TickIcon = ({
  width,
  height,
  title,
  color,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1792 1792"
    fill={color}
  >
    <title>{title}</title>
    <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" />
  </svg>
)

TickIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
  color: PropTypes.string,
}

TickIcon.defaultProps = {
  width: 20,
  height: 20,
  title: 'OK',
  color: 'currentColor',
}

export default TickIcon
